import React, { useEffect, useState, useMemo } from 'react';
import { GetLicensesList, GetLicensesTrends } from '../api/licenses';
import PageHeader from '../components/PageHeader';
import StatCard from '../components/StatCard';
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer,
  CartesianGrid, PieChart, Pie, Cell, Legend, LabelList, LineChart, Line
} from 'recharts';
import Snackbar from '../components/Snackbar';
import Table from '../components/Table';
import { format, parseISO } from 'date-fns';
import { pl } from 'date-fns/locale';
import { useAuth } from '../store/auth';
import {BsClock, BsAlarm, BsCalendar} from 'react-icons/bs';
import PageHeaderPortal from '../components/PageHeaderPortal';

export default function Dashboard() {
  const [licenses, setLicenses] = useState([]);
    const [licenseslastlogin, setLicenseslastlogin] = useState([]);

    const [licensesnew, setLicensesnew] = useState([]);

  const [loading, setLoading] = useState(true);
  const [licensesTrends, setLicensesTrends] = useState([]);
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
  const today = new Date();

  let logedUser = useAuth((state)=>state.user);
useEffect(() => {
  const fetchAllData = async () => {
    setLoading(true);
    try {
      const [licensesData, trendsData] = await Promise.all([
        GetLicensesList(),
        GetLicensesTrends()
      ]);

      // Licencje
     const now = new Date();

const today =
    `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;

const mappedLicenseslastlogin = licensesData.data
  .filter(item => item.last_login?.startsWith(today))
  .map(item => ({
    id: item.subscriber_id,
    license_name: item.license_name,
    shop_name: item.shop_name,
    client_email: item.client_email,
    shop_expireDate: item.shop_expireDate,
    last_login: item.last_login,
    newAcount: item.newAcount,
    vendorId: item.vendorId,
    us_name: item.us_name,
    CompnyName: item.CompnyName,
  }));
  const mappedLicensesnew = licensesData.data
  .filter(item => item.newAcount==1)
  .map(item => ({
    id: item.subscriber_id,
    license_name: item.license_name,
    shop_name: item.shop_name,
    client_email: item.client_email,
    shop_expireDate: item.shop_expireDate,
    last_login: item.last_login,
    newAcount: item.newAcount,
    vendorId: item.vendorId,
    us_name: item.us_name,
    CompnyName: item.CompnyName,
  }));
  const mappedLicenses = licensesData.data
  
  .map(item => ({
    id: item.subscriber_id,
    license_name: item.license_name,
    shop_name: item.shop_name,
    client_email: item.client_email,
    shop_expireDate: item.shop_expireDate,
    last_login: item.last_login,
    newAcount: item.newAcount,
    vendorId: item.vendorId,
    us_name: item.us_name,
    CompnyName: item.CompnyName,
  }));

setLicenses(mappedLicenses);
setLicensesnew(mappedLicensesnew);
setLicenseslastlogin(mappedLicenseslastlogin);

      // Trendy
  const formattedTrends = (trendsData?.data.licenseStats || []).map(item => ({
  miesiac: item.miesiac,
  nowe: Number(item.nowe),
  przedluzone: Number(item.przedluzone),
  aktywne: Number(item.aktywne),
}));
      setLicensesTrends(formattedTrends);

    } catch (err) {
      console.error(err);
      setToast({ open: true, message: err.message, severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  fetchAllData();
}, []);


  // Podstawowe wskaźniki
  const totalLicenses = licenses.length;
  const activeLicenses = licenses.filter(l => l.shop_expireDate && new Date(l.shop_expireDate) >= today).length;
  const expiredLicenses = licenses.filter(l => l.shop_expireDate && new Date(l.shop_expireDate) < today).length;
  const newAccounts = licenses.filter(l => String(l.newAcount) === '1').length;

  // Licencje wygasające w 10 dni
  const expiringSoon10 = licenses.filter(l => {
    if (!l.shop_expireDate) return false;
    const expDate = new Date(String(l.shop_expireDate).replace(' ', 'T'));
    const diffDays = Math.ceil((expDate - today) / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 10;
  }).length;
  const expiringSoon5 = licenses.filter(l => {
    if (!l.shop_expireDate) return false;
    const expDate = new Date(String(l.shop_expireDate).replace(' ', 'T'));
    const diffDays = Math.ceil((expDate - today) / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 5;
  }).length;
  const expiringSoon15 = licenses.filter(l => {
    if (!l.shop_expireDate) return false;
    const expDate = new Date(String(l.shop_expireDate).replace(' ', 'T'));
    const diffDays = Math.ceil((expDate - today) / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 15;
  }).length;
  const expiringSoon20 = licenses.filter(l => {
    if (!l.shop_expireDate) return false;
    const expDate = new Date(String(l.shop_expireDate).replace(' ', 'T'));
    const diffDays = Math.ceil((expDate - today) / (1000 * 60 * 60 * 24));
    return diffDays > 0 && diffDays <= 20;
  }).length;

  // Licencje według typu (zaokrąglone liczby)
  const licensesByType = useMemo(() => {
    const counts = {};
    licenses.forEach(l => {
      const key = l.license_name || 'Brak nazwy';
      counts[key] = (counts[key] || 0) + 1;
    });
    return Object.keys(counts).map((k, i) => ({
      name: k,  // podział 1, 2, 3
      Licencje: counts[k],
      label: k
    }));
  }, [licenses]);

  // Licencje według dystrybutora (top 5)
  const licensesByVendor = useMemo(() => {
    const counts = {};
    licenses.forEach(l => {
      const key = l.CompnyName || 'Nieprzypisany';
      counts[key] = (counts[key] || 0) + 1;
    });
    return Object.entries(counts)
      .sort((a, b) => b[1] - a[1])
      .slice(0, 5)
      .map(([name, Licencje]) => ({ name, Licencje }));
  }, [licenses]);


  // Podział na aktywne/wygasłe dla pie chart
  const statusPieData = [
    { name: 'Aktywne', value: activeLicenses },
    { name: 'Wygasły', value: expiredLicenses }
  ];
  const pieColors = ['#16a34a', '#dc2626'];

  // Tabela z danymi szczegółowymi
  const columns = [
    { field: 'shop_name', headerName: 'Klient', width: 150 },
    { field: 'license_name', headerName: 'Licencja', width: 100 },
  
    {
      field: 'shop_expireDate',
      headerName: 'Data wygaśnięcia',
      width: 140,
      renderCell: (params) => params.value ? format(parseISO(String(params.value).replace(' ', 'T')), 'yyyy-MM-dd', { locale: pl }) : '-'
    },
   
    {
      field: 'status',
      headerName: 'Status',
      width: 100,
      renderCell: (params) => {
        if (params.row.newAcount === '1') return <span className="text-yellow-600 font-medium">Nie wysłano</span>;
        if (!params.row.shop_expireDate) return <span className="text-gray-400">Brak daty</span>;
        return new Date(params.row.shop_expireDate) < today
          ? <span className="text-red-500 font-medium">Wygasła</span>
          : <span className="text-green-500 font-medium">Aktywna</span>;
      }
    }
  ];
const expirationCards = [
  {
    title: "Wygasające w 5 dni",
    description: "Licencje wymagające natychmiastowej reakcji.",
    value: expiringSoon5,
    color: "red",
    icon: BsClock,
  },
  {
    title: "Wygasające w 10 dni",
    description: "Licencje, które należy zaplanować do odnowienia.",
    value: expiringSoon10,
    color: "orange",
    icon: BsAlarm,
  },
  {
    title: "Wygasające w 15 dni",
    description: "Licencje wymagające monitorowania.",
    value: expiringSoon15,
    color: "yellow",
    icon: BsCalendar,
  },
  {
    title: "Wygasające w 20 dni",
    description: "Licencje ważne, ale wymagające uwagi.",
    value: expiringSoon20,
    color: "green",
    icon: BsClock,
  },
];
  return (
    <div>
      <PageHeaderPortal title="Panel główny" subtitle="Przegląd licencji i statystyki dla użytkownika" />

      {/* Statystyki główne */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3 mb-3">
        <StatCard icon={<BsCalendar />} color="gray" label="Wszystkie licencje" value={totalLicenses} description="Całkowita liczba licencji w systemie" />
        <StatCard icon={<BsCalendar />} color="green" label="Aktywne" value={activeLicenses} description="Licencje aktualnie aktywne" />
        <StatCard icon={<BsCalendar />} color="orange" label="Wygasłe" value={expiredLicenses} description="Licencje, które wygasły" />
        <StatCard icon={<BsCalendar />} color="red" label="Nowe konta" value={newAccounts} description="Konta, które nie otrzymały licencji" />
      </div>
      

<div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-3 mb-3">
  {expirationCards.map((card, index) => {
    const Icon = card.icon;

    const colors = {
      red: {
        icon: "text-red-500 bg-red-50",
        number: "text-red-600",
        border: "hover:border-red-200",
      },
      orange: {
        icon: "text-orange-500 bg-orange-50",
        number: "text-orange-600",
        border: "hover:border-orange-200",
      },
      yellow: {
        icon: "text-yellow-500 bg-yellow-50",
        number: "text-yellow-600",
        border: "hover:border-yellow-200",
      },
      green: {
        icon: "text-green-500 bg-green-50",
        number: "text-green-600",
        border: "hover:border-green-200",
      },
    };

    return (
      <div
        key={index}
        className={`
          bg-white
          rounded-xs
          border
          border-gray-200
          p-3
        
         
          ${colors[card.color].border}
          transition-all
          duration-200
        `}
      >
        <div className="flex items-start justify-between">
          <div
            className={`
              flex
              items-center
              justify-center
              w-10
              h-10
              rounded-lg
              ${colors[card.color].icon}
            `}
          >
            <Icon className="w-5 h-5" />
          </div>

          <span
            className={`
              text-xl
              font-bold
              ${colors[card.color].number}
            `}
          >
            {card.value}
          </span>
        </div>

        <div className="mt-2">
          <h4 className="font-semibold text-gray-900">
            {card.title}
          </h4>

          <p className="mt-1 text-xs text-gray-500 leading-relaxed">
            {card.description}
          </p>
        </div>
      </div>
    );
  })}
</div>
<div className="grid grid-cols-4 gap-3 mb-3">
  {/* Kolumna 1 - Wykres */}
 


  {/* Rozkład typów licencji */}
  <div className="bg-white rounded-xs border border-gray-200 col-span-2 overflow-hidden">
    <div className="px-4 py-4 border-b border-gray-100">
      <h3 className="text-normal font-semibold text-gray-900">
        Rozkład typów licencji
      </h3>
      <p className="mt-1 text-xs md:text-sm text-gray-500">
        Liczba aktywnych licencji według typu produktu.
      </p>
    </div>

    <div className="p-2">
      <ResponsiveContainer width="100%" height={260}>
        <BarChart
          data={licensesByType}
          layout="vertical"
          margin={{ top: 5, right: 40, left: 20, bottom: 5 }}
        >
          <CartesianGrid
            horizontal={false}
            stroke="#f3f4f6"
          />

          <XAxis
            type="number"
            allowDecimals={false}
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <YAxis
            type="category"
            dataKey="name"
            width={90}
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            contentStyle={{
              borderRadius: 10,
              border: "1px solid #e5e7eb",
              fontSize: 13
            }}
          />

          <Bar
            dataKey="Licencje"
            fill="#6366f1"
            radius={[0, 8, 8, 0]}
            barSize={18}
          >
            <LabelList
              dataKey="Licencje"
              position="right"
              style={{
                fontSize: 12,
                fontWeight: 600,
                fill: "#374151"
              }}
            />
          </Bar>

        </BarChart>
      </ResponsiveContainer>
    </div>
  </div>


  {/* Status licencji */}
  <div className="bg-white rounded-xs border border-gray-200 col-span-2 overflow-hidden">

    <div className="px-5 py-4 border-b border-gray-100">
      <h3 className="text-base font-semibold text-gray-900">
        Status licencji
      </h3>

      <p className="mt-1 text-xs md:text-sm text-gray-500">
        Aktualny podział licencji aktywnych i wygasłych.
      </p>
    </div>


    <div className="p-2">

      <ResponsiveContainer width="100%" height={260}>
        <BarChart
          data={statusPieData}
          layout="vertical"
          margin={{ top: 5, right: 40, left: 20, bottom: 5 }}
        >

          <CartesianGrid
            horizontal={false}
            stroke="#f3f4f6"
          />

          <XAxis
            type="number"
            allowDecimals={false}
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <YAxis
            type="category"
            dataKey="name"
            width={90}
            tick={{ fontSize: 12 }}
            axisLine={false}
            tickLine={false}
          />

          <Tooltip
            contentStyle={{
              borderRadius: 10,
              border: "1px solid #e5e7eb",
              fontSize: 13
            }}
          />

          <Bar
            dataKey="value"
            radius={[0, 8, 8, 0]}
            barSize={18}
          >

            {statusPieData.map((entry, index) => (
              <Cell
                key={index}
                fill={
                  entry.name === "Aktywne"
                    ? "#22c55e"
                    : "#ef4444"
                }
              />
            ))}

            <LabelList
              dataKey="value"
              position="right"
              style={{
                fontSize: 12,
                fontWeight: 600,
                fill: "#374151"
              }}
            />

          </Bar>

        </BarChart>
      </ResponsiveContainer>

    </div>

  </div>







</div>
   {(logedUser?.role === "Administrator" || logedUser?.role === "Developer") ? (  <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-4 mb-3">
      



        {/* Top dystrybutorów */}
      <div className="bg-white rounded-xs border border-gray-200 overflow-hidden sm:col-span-2">
  <div className="px-4 py-4 border-b border-gray-100">
    <div className="flex items-center justify-between">
      <div>
        <h3 className="text-base font-semibold text-gray-900">
          Licencje względem aktywności
        </h3>
        <p className="mt-1 text-sm text-gray-500">
          Porównanie aktywnych, przedłużonych oraz nowych licencji w kolejnych miesiącach.
        </p>
      </div>
    </div>
  </div>

  <div className="p-2">
    <ResponsiveContainer width="100%" height={320}>
      <LineChart
        data={licensesTrends}
        margin={{ top: 10, right: 20, left: 0, bottom: 10 }}
      >
        <CartesianGrid
          stroke="#f3f4f6"
          strokeDasharray="3 3"
          vertical={false}
        />

        <XAxis
          dataKey="miesiac"
          tick={{ fontSize: 12, fill: "#6b7280" }}
          axisLine={false}
          tickLine={false}
        />

        <YAxis
          allowDecimals={false}
          tick={{ fontSize: 12, fill: "#6b7280" }}
          axisLine={false}
          tickLine={false}
        />

        <Tooltip
          contentStyle={{
            borderRadius: "10px",
            border: "1px solid #e5e7eb",
            boxShadow: "0 8px 20px rgba(0,0,0,.08)",
            fontSize: "13px",
          }}
        />

        <Legend
          verticalAlign="top"
          align="right"
          iconType="circle"
          wrapperStyle={{
            fontSize: "13px",
            paddingBottom: "20px",
          }}
        />

        <Line
          type="monotone"
          dataKey="aktywne"
          name="Aktywne"
          stroke="#4f46e5"
          strokeWidth={1}
          dot={{ r: 3 }}
          activeDot={{ r: 6 }}
        />

        <Line
          type="monotone"
          dataKey="przedluzone"
          name="Przedłużone"
          stroke="#22c55e"
          strokeWidth={1}
          dot={{ r: 3 }}
          activeDot={{ r: 6 }}
        />

        <Line
          type="monotone"
          dataKey="nowe"
          name="Nowe"
          stroke="#f59e0b"
          strokeWidth={1}
          dot={{ r: 3 }}
          activeDot={{ r: 6 }}
        />
      </LineChart>
    </ResponsiveContainer>
  </div>
</div>
      </div>):('')}
      {/* Wykresy różne style */}
    

      {/* Tabela szczegółowa */}


    <div className="grid grid-cols-1 xl:grid-cols-2 gap-3 mb-6">
  <section className="bg-white rounded-xs border border-gray-200 overflow-hidden">
    <div className="px-4 py-4 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-base font-semibold text-gray-900">
            Dzisiaj zalogowani
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Użytkownicy, którzy zalogowali się dzisiaj.
          </p>
        </div>

        <span className="inline-flex items-center rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-700">
          {licenseslastlogin.length}
        </span>
      </div>
    </div>

    <div className="p-4">
      <Table
        columns={columns}
        data={licenseslastlogin}
        loading={loading}
      />
    </div>
  </section>

  <section className="bg-white rounded-xs border border-gray-200 overflow-hidden">
    <div className="px-4 py-4 border-b border-gray-100">
      <div className="flex items-center justify-between">
        <div>
          <h3 className="text-base font-semibold text-gray-900">
            Licencje wymagające uwagi
          </h3>
          <p className="mt-1 text-sm text-gray-500">
            Nowe licencje oraz wpisy wymagające weryfikacji.
          </p>
        </div>

        <span className="inline-flex items-center rounded-full bg-amber-100 px-3 py-1 text-xs font-medium text-amber-700">
          {licensesnew.length}
        </span>
      </div>
    </div>

    <div className="p-4">
      <Table
        columns={columns}
        data={licensesnew}
        loading={loading}
      />
    </div>
  </section>
</div>
     

      <Snackbar
        open={toast.open}
        message={toast.message}
        onClose={() => setToast({ ...toast, open: false })}
        severity={toast.severity}
      />
    </div>
  );
}
